import { ITask } from "@/interfaces/dashboard.interface";

// Mock data for Kanban board - Gestão de Tarefas
// Exact colors from Figma design
export const mockKanbanTasks: ITask[] = [
  // PARA FAZER (TODO) - 3 tasks
  {
    id: "task-1",
    taskName: "Nome da Tarefa",
    responsible: { name: "Ricardo Portas", avatar: "" },
    date: "15/05/2025",
    stage: "Desenvolvimento",
    status: "pendente",
    project: "Projeto Bem Estar",
    checked: false,
    column: "todo",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-1-1", text: "Checklist da tarefa", checked: true },
      { id: "check-1-2", text: "Checklist da tarefa", checked: false },
      { id: "check-1-3", text: "Checklist da tarefa", checked: false },
    ],
  },
  {
    id: "task-2",
    taskName: "Nome da Tarefa",
    responsible: { name: "Filemom Paulo", avatar: "" },
    date: "16/05/2025",
    stage: "Pré-Produção",
    status: "pendente",
    project: "Curta Metragem XYZ",
    checked: false,
    column: "todo",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-2-1", text: "Checklist da tarefa", checked: false },
      { id: "check-2-2", text: "Checklist da tarefa", checked: false },
    ],
  },
  {
    id: "task-3",
    taskName: "Nome da Tarefa",
    responsible: { name: "Maria Silva", avatar: "" },
    date: "17/05/2025",
    stage: "Produção",
    status: "pendente",
    project: "Documentário ABC",
    checked: false,
    column: "todo",
    tags: [
      { color: "#DC4426", label: "Urgente" }, // Laranja
      { color: "#F2C71E", label: "Em Revisão" }, // Amarelo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-3-1", text: "Checklist da tarefa", checked: true },
      { id: "check-3-2", text: "Checklist da tarefa", checked: true },
      { id: "check-3-3", text: "Checklist da tarefa", checked: false },
    ],
  },

  // FAZENDO (DOING) - 2 tasks
  {
    id: "task-4",
    taskName: "Nome da Tarefa",
    responsible: { name: "João Santos", avatar: "" },
    date: "18/05/2025",
    stage: "Produção",
    status: "confirmado",
    project: "Série Drama 123",
    checked: false,
    column: "doing",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#2078D7", label: "Design/UI" }, // Azul
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-4-1", text: "Checklist da tarefa", checked: true },
      { id: "check-4-2", text: "Checklist da tarefa", checked: false },
    ],
  },
  {
    id: "task-5",
    taskName: "Nome da Tarefa",
    responsible: { name: "Ricardo Portas", avatar: "" },
    date: "19/05/2025",
    stage: "Pós-Produção",
    status: "confirmado",
    project: "Projeto Bem Estar",
    checked: false,
    column: "doing",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#F2C71E", label: "Em Revisão" }, // Amarelo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-5-1", text: "Checklist da tarefa", checked: false },
      { id: "check-5-2", text: "Checklist da tarefa", checked: false },
      { id: "check-5-3", text: "Checklist da tarefa", checked: true },
    ],
  },

  // CONCLUÍDAS (DONE) - 4 tasks
  {
    id: "task-6",
    taskName: "Nome da Tarefa",
    responsible: { name: "Filemom Paulo", avatar: "" },
    date: "20/05/2025",
    stage: "Finalização",
    status: "confirmado",
    project: "Curta Metragem XYZ",
    checked: true,
    column: "done",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-6-1", text: "Checklist da tarefa", checked: true },
      { id: "check-6-2", text: "Checklist da tarefa", checked: true },
    ],
  },
  {
    id: "task-7",
    taskName: "Nome da Tarefa",
    responsible: { name: "Maria Silva", avatar: "" },
    date: "21/05/2025",
    stage: "Entrega",
    status: "confirmado",
    project: "Documentário ABC",
    checked: true,
    column: "done",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-7-1", text: "Checklist da tarefa", checked: true },
      { id: "check-7-2", text: "Checklist da tarefa", checked: true },
      { id: "check-7-3", text: "Checklist da tarefa", checked: true },
    ],
  },
  {
    id: "task-8",
    taskName: "Nome da Tarefa",
    responsible: { name: "João Santos", avatar: "" },
    date: "22/05/2025",
    stage: "Comercialização",
    status: "confirmado",
    project: "Série Drama 123",
    checked: true,
    column: "done",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-8-1", text: "Checklist da tarefa", checked: true },
      { id: "check-8-2", text: "Checklist da tarefa", checked: true },
    ],
  },
  {
    id: "task-9",
    taskName: "Nome da Tarefa",
    responsible: { name: "Ricardo Portas", avatar: "" },
    date: "23/05/2025",
    stage: "Arquivo",
    status: "confirmado",
    project: "Projeto Bem Estar",
    checked: true,
    column: "done",
    tags: [
      { color: "#13D480", label: "Improvisação/Gestão" }, // Verde
      { color: "#7846FF", label: "Prioridade/Sessão" }, // Roxo
    ],
    description: "Lorem ipsum dolor sit amet consectetur. Urna augue gravida id pellentesque donec dolor velit magna.",
    assignees: [
      { name: "Ricardo Portas", avatar: "" },
      { name: "Filemom Paulo", avatar: "" },
      { name: "Maria Silva", avatar: "" },
      { name: "João Santos", avatar: "" },
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    checklist: [
      { id: "check-9-1", text: "Checklist da tarefa", checked: true },
      { id: "check-9-2", text: "Checklist da tarefa", checked: true },
      { id: "check-9-3", text: "Checklist da tarefa", checked: true },
      { id: "check-9-4", text: "Checklist da tarefa", checked: true },
    ],
  },
];
